import { useRef, useState, useEffect } from "react";
import useAuth from "../hooks/useAuth";
import { useNavigate, useLocation } from "react-router-dom";
import { Container, Form, Toast, ToastContainer } from "react-bootstrap";

import axios from "../api/axios";
import { ROLES } from "../models/Roles";
const LOGIN_URL = "/api/v1/auth/login";

const Login = () => {
  const { setAuth } = useAuth();

  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";

  const emailRef = useRef();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    emailRef.current?.focus();
  }, []);

  useEffect(() => {
    setErrMsg("");
  }, [email, password]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    try {
      setSubmitting(true);
      var loginFormData = new FormData();
      loginFormData.append("email", email);
      loginFormData.append("password", password);
      const response = await axios.post(LOGIN_URL, loginFormData, {
        headers: { "Content-Type": "multipart/form-data" },
        withCredentials: true,
      });
      //console.log("response:", response);
      var data = response?.data?.data;
      //console.log(JSON.stringify(data));
      //console.log(JSON.stringify(response));
      const accessToken = data?.accessToken;
      const refreshToken = data?.refreshToken;
      var roles = [ROLES.User];
      if (data?.user?.isAdmin) {
        roles.push(ROLES.Administrator);
      }
      if (data?.user?.isPending) {
        roles.push(ROLES.Pending);
      }
      if (data?.user?.isDisabled) {
        roles.push(ROLES.Disabled);
      }
      //console.log("roles", roles);
      setAuth({ user: email, pwd: password, roles, accessToken, refreshToken });
      setEmail("");
      setPassword("");
      navigate(from, { replace: true });
    } catch (err) {
      if (!err?.response) {
        setErrMsg("No Server Response");
      } else if (err.response?.status === 400) {
        setErrMsg("Missing Email or Password");
      } else if (err.response?.status === 401) {
        setErrMsg("Unauthorized");
      } else {
        setErrMsg("Login Failed");
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Container className="my-3">
      <ToastContainer className="p-3" position="top-end">
        <Toast
          bg="danger"
          onClose={() => setErrMsg("")}
          show={errMsg !== ""}
          delay={5000}
          autohide
        >
          <Toast.Body className="text-white">{errMsg}</Toast.Body>
        </Toast>
      </ToastContainer>
      <h1 className="text-center">Sign In</h1>
      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3" controlId="email">
          <Form.Label>Email:</Form.Label>
          <Form.Control
            type="text"
            ref={emailRef}
            autoComplete="off"
            onChange={(e) => setEmail(e.target.value)}
            value={email}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3" controlId="password">
          <Form.Label>Password:</Form.Label>
          <Form.Control
            type="password"
            onChange={(e) => setPassword(e.target.value)}
            value={password}
            required
          />
        </Form.Group>
        <p className="text-center">
          <div
            className="custom-button primary"
            onClick={handleSubmit}
            disabled={submitting}
          >
            Sign In
          </div>
        </p>
      </Form>
      <p className="mt-3 text-center">
        Need an Account?
        <br />
        <div
          className="custom-button primary"
          onClick={() => {
            navigate("/register");
          }}
        >
          Sign Up
        </div>
      </p>
    </Container>
  );
};

export default Login;
